import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LeoFullBody } from './LeoMascot';

export default function Footer() {
  const {pathname}=useLocation();
  if (/^\/ebooks\/.+/.test(pathname)) return null;
  return (
    <footer className="bg-brown text-white relative overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          {/* Left: Logo + tagline */}
          <div className="text-center md:text-left">
            <h3 className="font-heading text-2xl text-sunshine mb-2">LionCubAI</h3>
            <p className="font-body text-white/80 text-sm max-w-xs">
              Making every child a proud little learner 🌟
            </p>
          </div>

          {/* Center: Links */}
          <nav className="flex flex-wrap justify-center gap-4 text-sm font-body">
            {[
              { to: '/', label: 'Home' },
              { to: '/ebooks', label: 'Books' },
              { to: '/stories', label: 'Make a story' },
              { to: '/math', label: 'Maths' },
              { to: '/songs', label: 'Songs' },
              { to: '/quizzes', label: 'Quizzes' },
              { to: '/privacy', label: 'Privacy' },
              { to: '/coloring', label: 'Coloring' },
              { to: '/games', label: 'Games' },
              { to: '/parents', label: 'For Parents' },
            ].map(link => (
              <Link
                key={link.to}
                to={link.to}
                className="text-white/70 hover:text-sunshine transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right: Leo waving */}
          <div className="w-20 h-20 hidden md:block opacity-60">
            <LeoFullBody mood="happy" />
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-white/50 text-xs font-body">
            &copy; {new Date().getFullYear()} LionCubAI &mdash; Made with ❤️ for little learners
          </p>
        </div>
      </div>
    </footer>
  );
}
